import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "¿Cuánto tiempo tardaré en ver resultados?",
    a: "La mayoría de mis clientes nota cambios reales (energía, ropa, fuerza) en 3-4 semanas. Los grandes cambios físicos llegan entre el mes 2 y el mes 6, dependiendo de tu punto de partida y tu objetivo (7-20 kg).",
  },
  {
    q: "Soy negado para cocinar y como mucho fuera. ¿Sirve igual?",
    a: "Sí. Diseño tu plan teniendo en cuenta tu realidad: comidas de empresa, restaurantes, viajes y cero ganas de cocinar. La clave es que sea sostenible para TI.",
  },
  {
    q: "No piso un gimnasio desde hace años, ¿podré seguir tu entrenamiento?",
    a: "Por supuesto. Empezamos desde donde estás, no desde donde 'deberías' estar. Tu progresión es semanal y siempre ajustada a ti.",
  },
  {
    q: "¿Qué diferencia hay entre online y presencial?",
    a: "El método y el seguimiento son los mismos. Si estás en Pamplona y prefieres trato cara a cara, el presencial te aporta evaluaciones físicas. El online da más flexibilidad horaria. Ambos funcionan.",
  },
  {
    q: "¿Cuánto cuesta?",
    a: "El precio depende del servicio y la duración del proceso. Cuéntame por WhatsApp tu situación y te paso una propuesta clara, sin compromiso.",
  },
  {
    q: "¿Y si no soy constante?",
    a: "Mi trabajo es precisamente ese: ayudarte a ser constante. Por eso revisamos cada semana, ajustamos lo que no funciona y celebramos los avances. No estás solo en esto.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="section-faq"
      className="relative bg-[#0F0F0F] py-24 sm:py-32 border-t border-zinc-900"
    >
      <div className="w-full max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-xs sm:text-sm text-[#FF5A1F] uppercase tracking-[0.25em] font-bold mb-6">
            06 — FAQ
          </p>
          <h2
            data-testid="faq-heading"
            className="font-display font-black uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter"
          >
            Lo que <span className="text-[#FF5A1F]">siempre</span> me preguntan.
          </h2>
        </div>

        <div className="mt-12">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-zinc-800"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-display font-bold uppercase tracking-tight text-lg sm:text-xl text-white hover:text-[#FF5A1F] hover:no-underline py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-zinc-400 text-base leading-relaxed pb-6 max-w-3xl"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
